import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "../axios/axios-config";
import { IList, INewList } from "../models/lists";

const BASE_URL = process.env.REACT_APP_MAIN;

const LEGAL_ENTITY_ROUTE = BASE_URL + "/api/v1/List/";

export class ListService {
  create = (item: INewList) => {
    return GlobalAxios.post(LEGAL_ENTITY_ROUTE, item);
  };

  getItemById = (id: string) => {
    return GlobalAxios.get<IList>(LEGAL_ENTITY_ROUTE + id);
  };

  updateItemById = ({ item, id }: { item: INewList; id: string }) => {
    return GlobalAxios.put(LEGAL_ENTITY_ROUTE + id, item);
  };

  list = (params?: any) => {
    return GlobalAxios.get<ISelectType[]>(LEGAL_ENTITY_ROUTE + "list", {
      params,
    });
  };
}

export default ListService;
